import { sanitize } from 'dompurify'

export const unsecableRawSpaces = (str) => str.replace(/\s([?!:»])/g, '\u00a0$1').replace(/(«)\s/g, '$1\u00a0')

export const unsecableSpaces = (str) => str.replace(/\s([?!:»])/g, '&nbsp;$1').replace(/(«)\s/g, '$1&nbsp;')

export const getSafeTemplate = (reactElement) => unsecableSpaces(sanitize(reactElement))

export const cleanText = (text) => text.replace(/(\s*&nbsp;\s*)+/g, '<span class="unbreak-spaces">&nbsp;</span>')